<template>
    <div class="app-container">
        <div class="map">
            <div>
                <div>{{ map.totalCount }}</div>
                <div>总报名人数</div>
            </div>
            <div>
                <div>{{ map.girlCount }}</div>
                <div>女生报名数</div>
            </div>
            <div>
                <div>{{ map.boyCount }}</div>
                <div>男生报名数</div>
            </div>
            <div>
                <div>{{ map.zjCount }}</div>
                <div>中技</div>
            </div>
            <div>
                <div>{{ map.gjCount }}</div>
                <div>高技</div>
            </div>
            <div>
                <div>{{ map.ybjsCount }}</div>
                <div>预备技师</div>
            </div>
            <div>
                <div>{{ map.yjfCount }}</div>
                <div>已缴费学生</div>
            </div>
            <div>
                <div>{{ map.ybdCount }}</div>
                <div>已报到人数</div>
            </div>
            <div>
                <div>{{ map.ybdl }}</div>
                <div>已报到率</div>
            </div>
        </div>
        <div class="list-container" v-loading="loading">
            <div>
                <div class="left">
                    <div>
                        统计年份：
                        <el-select v-model="year" placeholder="请选择">
                            <el-option v-for="item in yearOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        统计类型：
                        <el-select v-model="type" placeholder="请选择">
                            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" @click="getStatistics">统计</el-button>
                </div>
                <div class="right">
                    <el-button type="primary" @click="exportData">导出</el-button>
                </div>
            </div>
            <div class="table-container">
                <el-table :data="list" style="width: 100%;" border max-height="560px">
                    <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                    <el-table-column :label="item.label" :align="item.align || 'center'" :width="item.minWidth"
                        :prop="item.prop" v-for="(item, index) in tableColumns" :key="index"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    data() {
        return {
            year: 2025,
            type: 1,
            list: [],
            map: {},
            yearOptions: [],
            typeOptions: [
                { label: '按分班人数', value: 1 },
                { label: '按中技专业', value: 2 },
                { label: '按高技专业', value: 3 },
                { label: '按预备技师专业', value: 4 },
                { label: '按接待老师', value: 5 },
                { label: '按来源', value: 6 },
                { label: '按日期', value: 7 },
            ],
            tableType: 1,
            loading: false,
        }
    },
    computed: {
        tableColumns() {
            if (this.tableType == 1) {
                return [
                    {
                        label: '新生班级',
                        prop: 'className',
                        align: 'left'
                    },
                    {
                        label: '班级人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                    {
                        label: '已报到',
                        prop: 'ybdCount',
                        minWidth: 100,
                    },
                    {
                        label: '未报到',
                        prop: 'wbdCount',
                        minWidth: 100,
                    }
                ]
            } else if (this.tableType == 2) {
                return [
                    {
                        label: '专业名称',
                        prop: 'bdzy',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            } else if (this.tableType == 3) {
                return [
                    {
                        label: '专业名称',
                        prop: 'bdzy',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            } else if (this.tableType == 4) {
                return [
                    {
                        label: '专业名称',
                        prop: 'bdzy',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            } else if (this.tableType == 5) {
                return [
                    {
                        label: '接待老师',
                        prop: 'jdls',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            } else if (this.tableType == 6) {
                return [
                    {
                        label: '新生报读毕业学校',
                        prop: 'graduationSchool',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            } else if (this.tableType == 7) {
                return [
                    {
                        label: '报名日期',
                        prop: 'submitTime',
                        align: 'left'
                    },
                    {
                        label: '人数',
                        prop: 'totalCount',
                        minWidth: 100,
                    },
                ]
            }
        }
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true)
    },
    methods: {
        async init() {
            const curYear = new Date().getFullYear()
            this.year = curYear
            for (let i = -1; i < 4; i++) {
                this.yearOptions.push({
                    label: curYear - i,
                    value: curYear - i
                })
            }
            this.getStatistics()
            this.$bus.emit('showNavSearch', false)
        },
        async getStatistics() {
            try {
                this.loading = true
                const { body, message, code } = await this.$http({
                    method: 'get',
                    url: '/xsgl/freshmanRegistration/findRegistrationStatistics',
                    params: {
                        year: this.year,
                        type: this.type
                    }
                })
                if (code == 'success') {
                    const { list, map } = body
                    this.list = list
                    this.map = map
                    this.tableType = this.type
                } else {
                    this.$message.error(message)
                }
            } finally {
                this.loading = false
            }
        },
        async exportData() {
            const typeLabel = this.typeOptions.find(item => item.value == this.type).label
            const fileName = `迎新统计${this.year}年${typeLabel}表`
            const titles = [
                this.tableColumns.map(item => {
                    return {
                        "title": item.label,
                        "width": item.minWidth || 100,
                        "align": item.align || "center",
                        "colspan": 1,
                        "rowspan": 1
                    }
                })
            ]
            const values = this.list.map(item => {
                const arr = []
                this.tableColumns.forEach(column => {
                    const value = item[column.prop]
                    arr.push({
                        value,
                        "width": column.minWidth || 100,
                        "align": column.align || "center",
                        "colspan": 1,
                        "rowspan": 1
                    })
                })
                return arr
            })
            this.$http({
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                data: qs.stringify({ 'rows': JSON.stringify(values), 'titles': JSON.stringify(titles), 'fileName': fileName }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then(res => {
                if (res.code === 'success') {
                    window.open(encodeURI('/apigw/' + res.body.xlsurl), '_blank')
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.app-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .map {
        height: 100px;
        display: grid;
        grid-template-columns: repeat(9, 1fr);
        align-items: center;

        >div {
            display: flex;
            flex-direction: column;
            align-items: center;
            border-left: 1px solid #d8dce5;
            gap: 4px;

            >div:first-child {
                color: var(--subjectColor);
                font-weight: bold;
                font-size: 18px;
            }

            &:first-child {
                border-left: none;
            }
        }
    }

    .list-container {
        flex: 1;
        height: 0;
        display: flex;
        flex-direction: column;

        >div {
            &:first-child {
                display: flex;
                justify-content: space-between;

                .left {
                    display: flex;
                    gap: 26px;
                    align-items: center;
                }
            }

            &:last-child {
                flex: 1;
                height: 0;
            }
        }

        .table-container {
            padding-top: 10px;
            height: calc(100% - 150px);
        }
    }
}
</style>